export const IDENTIFICATION_KEYS = {
  wmsToolKey: 'wms_identification',
  identificationToolKey: 'identification'
};
